export default "__VITE_ASSET__bc59dd1e__$_?component__"